var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115.685,
    height: 115.685,
    viewBox: "0 0 115.685 115.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.194,
    y1: 0.21,
    x2: 1.461,
    y2: 1.187,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_44",
    x: 0,
    y: 0,
    width: 115.685,
    height: 115.685,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29918",
    "data-name": "Group 29918",
    transform: "translate(-1279.501 -3180.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1279.5, 3180.5)",
    filter: "url(#Union_44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_44-2",
    "data-name": "Union 44",
    d: "M11994.455-10920.315a2.309,2.309,0,0,1-2.31-2.309v-3.544c.036-2.124-3.139-3.437-4.614-1.913l-2.508,2.508a2.308,2.308,0,0,1-3.266,0l-5.5-5.5a2.308,2.308,0,0,1,0-3.266c1.4-1.587,4.319-3.208,2.729-5.7-.525-1.57-2.535-1.5-4.2-1.431a13.005,13.005,0,0,1-1.479.009,2.309,2.309,0,0,1-2.31-2.309v-7.777a2.306,2.306,0,0,1,2.307-2.307,11.765,11.765,0,0,1,1.457.007c1.666.066,3.73.136,4.223-1.431,1.572-2.515-1.286-4.068-2.729-5.7a2.308,2.308,0,0,1,0-3.266l5.5-5.5a2.308,2.308,0,0,1,3.266,0l2.508,2.508c1.479,1.527,4.65.205,4.614-1.916v-3.543a2.311,2.311,0,0,1,2.31-2.31h7.774a2.309,2.309,0,0,1,2.309,2.31v3.543c-.036,2.125,3.142,3.44,4.617,1.916l2.509-2.508a2.307,2.307,0,0,1,3.265,0l5.5,5.5c2.146,2.194-1.222,4.334-2.508,5.773-1.527,1.479-.205,4.65,1.916,4.617h3.544a2.306,2.306,0,0,1,2.309,2.307v7.777c-.111,2.384-2.025,2.336-3.975,2.287-1.687-.042-3.4-.084-4.012,1.443-2.514,3.8,5.808,5.342,2.726,8.966l-5.5,5.5a2.307,2.307,0,0,1-3.265,0c-1.591-1.4-3.209-4.315-5.705-2.729-3.292,1.319.719,7.774-3.729,7.986Z",
    transform: "translate(-11945.5 11000.5)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-brain",
    "data-name": "Icon awesome-brain",
    d: "M10.948,0A3.359,3.359,0,0,0,7.7,2.537c-.042,0-.074-.011-.116-.011A3.372,3.372,0,0,0,4.211,5.895a3.1,3.1,0,0,0,.089.737,4.174,4.174,0,0,0-2.179,5.732A4.2,4.2,0,0,0,2.6,19.89a3.857,3.857,0,0,0-.074.742,3.787,3.787,0,0,0,3.79,3.79,3.569,3.569,0,0,0,.632-.063,3.781,3.781,0,0,0,7.369-1.2V3.369A3.372,3.372,0,0,0,10.948,0ZM30.317,16A4.189,4.189,0,0,0,28.2,12.364a4.143,4.143,0,0,0,.437-1.837,4.211,4.211,0,0,0-2.616-3.895,3.337,3.337,0,0,0-3.279-4.105c-.042,0-.079.011-.116.011A3.362,3.362,0,0,0,16,3.369v19.79a3.781,3.781,0,0,0,7.369,1.2,3.569,3.569,0,0,0,.632.063,3.787,3.787,0,0,0,3.79-3.79,3.857,3.857,0,0,0-.074-.742A4.211,4.211,0,0,0,30.317,16Z",
    transform: "translate(1317 3220)",
    fill: "#07111a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.ac4c1a58d44e1d8948cbd5bd8812038a.svg";
export { ForwardRef as ReactComponent };